import script from "./EducationEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationEditor.vue?vue&type=script&setup=true&lang=js"

import "./EducationEditor.vue?vue&type=style&index=0&id=b01b0a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b01b0a7a"]])

export default __exports__